import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { EventService } from "../services/EventService/EventService";
import {ProductService} from "../services/EventService/ProductService";
import PageHelper from "./PageHelper";
import PhotoDetails from "../types/PhotoDetails";
import Product from "../types/Product";

const Photo: React.FC = () => {
    const { eventId: eventIdParam, photoId: photoIdParam } = useParams<{ eventId?: string; photoId?: string }>(); // Get the event ID parameter from the URL
    const [photoDetails, setPhotoDetails] = useState<PhotoDetails>();
    const [products, setProducts] = useState<Product[]>([]);

    const SHIPPING_COST = 8.95;

    const openPayPalWindow = () => {
        const newWindow = window.open('https://www.paypal.com/us/cgi-bin/webscr?cmd=xpt/cps/popup/OLCWhatIsPayPal-outside','olcwhatispaypal','toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=400, height=350');
        if (newWindow) newWindow.opener = null;
    }

    useEffect(() => {
        const loadPhotoDetails = async () => {
            try {
                const selectedEventId = eventIdParam;
                if (!selectedEventId) {
                    throw new Error("Event ID not provided");
                }
                const selectedPhotoId = photoIdParam;
                if (!selectedPhotoId) {
                    throw new Error("Photo ID not provided");
                }
                const photoDetails = await EventService.fetchPhotoDetails(selectedEventId, selectedPhotoId);
                setPhotoDetails(photoDetails);
            } catch (error) {
                console.error("Error fetching photo details:", error);
            }
        };

        loadPhotoDetails();
    }, [eventIdParam, photoIdParam]);

    useEffect(() => {
        if (!photoDetails) return;
        
        const loadProducts = async () => {
            try {
                const products = await ProductService.fetchAllProducts();
                setProducts(products);
            } catch (error) {
                console.error("Error fetching products:", error);
            }
        };
        loadProducts();
    }, [photoDetails]);

    function substringBeforePeriod(str: string): string {
        const indexOfPeriod = str.indexOf('.');
        return indexOfPeriod === -1 ? str : str.substring(0, indexOfPeriod);
    }  

    const handlePreviousPicture = () => {
        if (photoDetails?.previousPicture) {
            const previousPictureUrl = `/photo/${photoDetails.id}/${photoDetails.previousPicture.id}`;
            window.location.href = previousPictureUrl; // Navigate to the previous photo URL
        }
    };

    const handleNextPicture = () => {
        if (photoDetails?.nextPicture) {
            const nextPictureUrl = `/photo/${photoDetails.id}/${photoDetails.nextPicture.id}`;
            window.location.href = nextPictureUrl; // Navigate to the next photo URL
        }
    };

    return (
        <div id="content">
            <div style={{ float: "left", width: '500px' }}>
                <h1>{photoDetails?.title}</h1>
            </div>
            <div style={{ float: "left", width: '330px' }}>
                <div style={{float: "left" }}>
                    <button className="pageButton" onClick={handlePreviousPicture} disabled={photoDetails?.previousPicture === null}>
                        &nbsp;&nbsp;{`< Previous`}&nbsp;&nbsp;</button>
                </div>
                <div style={{float: "left", paddingRight: "10px" }} id="navsub"><a href={`/event/${photoDetails?.id}/${photoDetails?.category.id}`}>Return to Category</a></div>
                <div style={{float: "left" }}>
                    <button className="pageButton" onClick={handleNextPicture} disabled={photoDetails?.nextPicture === null}>
                        &nbsp;&nbsp;{`Next >`}&nbsp;&nbsp;</button>
                </div>
                
            </div>

            <div style={{ float: "left", width: '610px' }}>
                <div id="cartImage">
                    <img alt={photoDetails?.selectedPicture?.id} src={photoDetails?.id && photoDetails.selectedPicture?.filename 
                        ? PageHelper.getImageSourceUrl(photoDetails.id, "image", photoDetails.selectedPicture.filename) 
                        : ""} />
                </div>

                <h2 style={{ marginTop: '20px' }}>Download your photo(s)</h2>
                <p>You may also choose to download this image as a file. Please allow 48 hours after purchase to receive a confirmation email with instructions to download your selected photographs.
                    Digital purchases are subject to a non-commercial license agreement. If you wish to use your image for a commercial purpose you need to negotiate a licensing fee with MyBajaPhoto.com.
                    Commercial license costs are handled on a case by case basis.
                </p>
                <table width="610px" style={{ border: '0px' }} cellSpacing={1} cellPadding={0}>
                    <tbody>
                    <tr>
                        <td valign="top"><strong>Sizes</strong></td>
                        <td valign="top"><strong>Resolution</strong></td>
                        <td valign="top"><strong>File Size</strong></td>
                        <td valign="top"><strong>Price</strong></td>
                        <td valign="top" style={{ width: '150px' }}></td>
                    </tr>

                    {products?.filter((product) => product.category === 'Digital')
                        .map((product) => (
                            <tr key={product.id}>
                                <td valign="top"><div dangerouslySetInnerHTML={{ __html: product.description }} /></td>
                                <td valign="top"><div dangerouslySetInnerHTML={{ __html: product.resolution }} /></td>
                                <td valign="top">{product.filesize}</td>
                                <td valign="top">${product.price}</td>
                                <td valign="top">
                                    <form id={product.name} target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">
                                        <input type="image" src="https://www.paypal.com/en_US/i/btn/btn_cart_LG.gif" style={{border:'0px'}} name="submit" alt="Make payments with PayPal - it's fast, free and secure!"/>
                                        <img alt="" style={{border:'0px'}} src="https://www.paypal.com/en_US/i/scr/pixel.gif" width="1" height="1"/>
                                        <input type="hidden" name="add" value="1"/>
                                        <input type="hidden" name="cmd" value="_cart"/>
                                        <input type="hidden" name="charset" value="utf-8"/>
                                        <input type="hidden" name="business" value="orders@mybajaphoto.com"/>
                                        <input type="hidden" name="item_name" value={`${product.name}_${photoDetails?.shortname}_${substringBeforePeriod(photoDetails?.selectedPicture?.filename || '')}`} />
                                        <input type="hidden" name="item_number" value={photoDetails?.selectedPicture?.id}/>
                                        <input type="hidden" name="amount" value={product.price}/>
                                        <input type="hidden" name="quantity" value="1"/>
                                        <input type="hidden" name="no_shipping" value="2"/>
                                        <input type="hidden" name="no_note" value="0"/>
                                        <input type="hidden" name="currency_code" value="USD"/>
                                        <input type="hidden" name="lc" value="US"/>
                                        <input type="hidden" name="bn" value="PP-ShopCartBF"/>
                                    </form>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <h2 style={{ marginTop: '20px' }}>Purchase a print</h2>
                <p>All photos are printed on Premium Fuji Pro Paper. Please allow 5-6 weeks for delivery.
			     All prints have the event name and date on them.
			     If you wish not to have this on your print, please indicate so in the comments section of your PayPal purchase.
			     All print orders require a ${SHIPPING_COST} shipping and handling fee (Continental US) in addition to 8.75% sales tax if your order is shipped to a California address. Additional shipping fees apply for orders shipped outside the US.
                </p>
                <table width="610px" style={{ border: '0px' }} cellSpacing={1} cellPadding={0}>
                    <tbody>
                    <tr>
                        <td valign="top"><strong>Size</strong></td>
                        <td valign="top"><strong>Price</strong></td>
                        <td valign="top" style={{ width: '150px' }}></td>
                    </tr>

                    {products?.filter((product) => product.category === 'Print')
                        .map((product) => (
                            <tr key={product.id}>
                                <td valign="top"><div dangerouslySetInnerHTML={{ __html: product.description }} /></td>
                                <td valign="top">${product.price}</td>
                                <td valign="top">
                                    <form id={product.name} target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">
                                        <input type="image" src="https://www.paypal.com/en_US/i/btn/btn_cart_LG.gif" style={{border:'0px'}} name="submit" alt="Make payments with PayPal - it's fast, free and secure!"/>
                                        <img alt="" style={{border:'0px'}} src="https://www.paypal.com/en_US/i/scr/pixel.gif" width="1" height="1"/>
                                        <input type="hidden" name="add" value="1"/>
                                        <input type="hidden" name="cmd" value="_cart"/>
                                        <input type="hidden" name="charset" value="utf-8"/>
                                        <input type="hidden" name="business" value="orders@mybajaphoto.com"/>
                                        <input type="hidden" name="item_name" value={`${product.name}_${photoDetails?.shortname}_${substringBeforePeriod(photoDetails?.selectedPicture?.filename || '')}`} />
                                        <input type="hidden" name="item_number" value={photoDetails?.selectedPicture?.id}/>
                                        <input type="hidden" name="amount" value={product.price}/>
                                        <input type="hidden" name="quantity" value="1"/>
                                        <input type="hidden" name="no_shipping" value="2"/>
                                        <input type="hidden" name="handling_cart" value={SHIPPING_COST}/>
                                        <input type="hidden" name="no_note" value="0"/>
                                        <input type="hidden" name="currency_code" value="USD"/>
                                        <input type="hidden" name="lc" value="US"/>
                                        <input type="hidden" name="bn" value="PP-ShopCartBF"/>
                                    </form>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

            </div>

            <div style={{ float: "left", marginLeft: '20px', width: '190px' }}>
                <h2>Details</h2>
                <p style={{textAlign:"center"}}>
                    <a href={photoDetails?.organizer.href} target="_blank" rel="noreferrer">
                        <img src={photoDetails?.organizer.logo} alt="Event Logo" style={{border:'0px'}}/>
                    </a>
                </p>
                <p><strong>Vehicle Number:</strong>&nbsp;{photoDetails?.selectedPicture?.caption}</p>
                <p><strong>Copyright:</strong>&nbsp;&#169;
                    {photoDetails?.year} MyBajaPhoto.com</p>
                <h2>Purchasing Information</h2>
                <p>You do not need to have a PayPal account to pay with a credit card.</p>
                <p>Your electronic payment will be processed entirely by PayPal.</p>
                <p>MyBajaPhoto.com does not store any of your personal information.</p>
                <p>&nbsp;</p>
                <form target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">
                    <input type="hidden" name="cmd" value="_cart" />
                    <input type="hidden" name="business" value="orders@mybajaphoto.com" />
                    <input type="image" src="/assets/images/paypal/paypal_btn.gif" style={{ border: "0" }} name="submit" alt="Make payments with PayPal - it's fast, free and secure!" />
                    <input type="hidden" name="display" value="1" />
                </form>
                <p>&nbsp;</p>
                <img onClick={openPayPalWindow} src="/assets/images/paypal/paypal_badge.gif" 
                    alt="Solution Graphics" style={{ border: 'none' }} />
            </div>
            <br style={{ clear: "both" }} />
            &nbsp;
        </div>
    );
}

export default Photo;